var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "c-article",
      class: _vm.width === "narrow" ? "c-article--narrow" : ""
    },
    [
      _c(
        "div",
        {
          ref: "content",
          staticClass: "c-article__content",
          class: { "c-article__content--crop": _vm.isCropped }
        },
        [_vm._t("content")],
        2
      ),
      _vm._v(" "),
      _vm.isCropped
        ? _c(
            "button",
            {
              staticClass:
                "c-button c-button--noboxshadow c-button--icon c-article__more",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.showAll()
                }
              }
            },
            [
              _c("span", { staticClass: "c-button--right" }, [
                _vm._v("Visa hela texten")
              ]),
              _vm._v(" "),
              _c("v-icon", {
                attrs: {
                  name: "icon-arrow",
                  size: "xxs",
                  cssModifiers: "c-article__more-icon"
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }